// extracted by mini-css-extract-plugin
module.exports = {"link":"NotificationCenter-NotificationCenter-link-b61ba255"};